import SnackbarRoot from './SnackbarRoot'

export default SnackbarRoot
